<template>
  <v-app-bar id="upp-bar" color="white" :flat="true" class="px-4">
    <div class="d-flex align-center">
      <v-icon color="primary" class="mr-2" size="large"> mdi-search-web </v-icon>
      <div class="text-primary text-h5 font-weight-bold">
        {{ $t('strings.data-discovery') }}
      </div>
    </div>
    <v-spacer></v-spacer>
    &emsp;
    <v-spacer></v-spacer>
  </v-app-bar>
  <!--Snackbar-->
  <v-snackbar v-model="snackbar" location="top" color="green" z-index="10000" timeout="5000">
    {{ snackbarText }}
    <v-btn color="white" @click="snackbar = false" variant="text">
      {{ $t('labels.close') }}
    </v-btn>
  </v-snackbar>
</template>

<script>
// import axios from 'axios'
import events from '@/mixins/events.js'
import utils from '@/mixins/utils.js'

export default {
  name: 'AppBar',
  mixins: [events, utils],
  props: ['mfConfig', 'realm'],
  data: function () {
    return {
      containerState: 'expanded',
      snackbar: false,
      snackbarText: '',
    }
  },
  mounted() {
    this.containerState = localStorage.getItem('sidenav') === 'opened' ? 'reduced' : 'expanded'

    document.addEventListener('sidenav-localstorage-changed', (event) => {
      this.containerState = event.detail.storage === 'opened' ? 'reduced' : 'expanded'
    })
  },
  components: {},
  methods: {
    //Export Datasources
  },
}
</script>

<style scoped>
main.expanded header#upp-bar {
  margin-left: 56px;
  width: calc(100% - 56px) !important;
}
main.reduced header#upp-bar {
  margin-left: 256px;
  width: calc(100% - 256px) !important;
}
.button-right {
  right: -15px;
}

.icon-large {
  font-size: 36px !important;
}
</style>
